import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
import { IData } from '../../helpers/interface';
import { useEffect, useState } from 'react';
import axios from 'axios';

interface IProps {
  moduleData: IData;
  isView: boolean;
  handleSumbit: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
}

const TController = ({
  moduleData,
  isView,
  handleSumbit,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
}: IProps) => {
  const [machineData, setMachine] = useState({});
  const [controllerRender, setControllerRender] = useState(false);

  useEffect(() => {
    axios
      .get('/api/machineRoutes/machineList/machineListForAutoComplete')
      .then((res) => {
        if (res.data) {
          setMachine(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            setControllerRender,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handleSumbit,
            machineData,
            handelDeleteRows,
            isOpenPopup,
            setIsOpenPopup,
            setPartIdx,
          }}
        />
        {/* <TFoot {...{ moduleData, isView }} /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
